import script from "./PracticePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PracticePage.vue?vue&type=script&setup=true&lang=js"

import "./PracticePage.vue?vue&type=style&index=0&id=23fdaa85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fdaa85"]])

export default __exports__